export const HEARTBEAT_ONLINE_MS = 180_000;
/** Parked T98s often send 0x0200 every few minutes. Use server receipt, not the device clock. */
export const GPS_FRESH_MS = 300_000;

export function isFreshTimestamp(iso: string | null | undefined, maxAgeMs: number, now = Date.now()): boolean {
  if (!iso) return false;
  const t = Date.parse(iso);
  if (!Number.isFinite(t)) return false;
  const age = now - t;
  return age >= -maxAgeMs && age <= maxAgeMs;
}

/** Prefer server `received_at`. Device `recorded_at` can be hours in the future. */
export function gpsFreshnessAt(
  receivedAt: string | null | undefined,
  recordedAt: string | null | undefined,
  now = Date.now(),
): string | null {
  if (receivedAt && isFreshTimestamp(receivedAt, GPS_FRESH_MS, now)) return receivedAt;
  if (receivedAt) return receivedAt;
  if (!recordedAt) return null;
  const t = Date.parse(recordedAt);
  if (!Number.isFinite(t) || t > now + 5_000) return null;
  return recordedAt;
}
